import KeyboardDoubleArrowLeft from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRight from "@mui/icons-material/KeyboardDoubleArrowRight";
import TodayIcon from "@mui/icons-material/Today";
import TuneIcon from "@mui/icons-material/Tune";
import Collapse from "@mui/material/Collapse";
import Stack from "@mui/material/Stack";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import type { TFunction } from "core/entities";
import type { TemporalFilterType } from "features/NewsEvents/entities";

export type DateRangeTypeToggleButtonsProps = {
  t: TFunction;
  value: TemporalFilterType[];
  onChange: (filters: TemporalFilterType[]) => void;
  isMobile: boolean;
};

export function DateRangeTypeToggleButtons({
  value,
  onChange,
  t,
  isMobile,
}: DateRangeTypeToggleButtonsProps) {
  return (
    <ToggleButtonGroup
      color="primary"
      onChange={(_, newValue) => {
        onChange(newValue);
      }}
      exclusive={false}
      value={value}
      sx={{
        "& .MuiToggleButtonGroup-grouped": {
          border: 0,
          "&:not(:first-of-type)": {
            borderInlineStart: (theme) => `1px solid ${theme.palette.divider}`,
          },
        },
      }}
    >
      <ToggleButton value="past">
        <Stack direction="row" gap={1}>
          <KeyboardDoubleArrowLeft fontSize={isMobile ? "medium" : "small"} />
          <Collapse
            appear={false}
            orientation="horizontal"
            in={!isMobile || value.includes("past")}
          >
            {t("past")}
          </Collapse>
        </Stack>
      </ToggleButton>
      <ToggleButton value="current">
        <Stack direction="row" gap={1}>
          <Collapse
            appear={false}
            orientation="horizontal"
            in={!isMobile || value.includes("current")}
          >
            {t("current")}
          </Collapse>
          <TodayIcon fontSize={isMobile ? "medium" : "small"} />
        </Stack>
      </ToggleButton>
      <ToggleButton value="future">
        <Stack direction="row" gap={1}>
          <Collapse
            appear={false}
            orientation="horizontal"
            in={!isMobile || value.includes("future")}
          >
            {t("future")}
          </Collapse>
          <KeyboardDoubleArrowRight fontSize={isMobile ? "medium" : "small"} />
        </Stack>
      </ToggleButton>
      <ToggleButton value="custom">
        <Stack direction="row" gap={1}>
          <Collapse
            appear={false}
            orientation="horizontal"
            in={!isMobile || value.includes("custom")}
          >
            {t("custom")}
          </Collapse>
          <TuneIcon fontSize={isMobile ? "medium" : "small"} />
        </Stack>
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
